import {Route} from "react-router-dom";
import UrlsConfig from "@/config/UrlsConfig";
import {lazy} from "react";

const OrdersAndAppointments = lazy(() => import("@/pages/MyOrders/OrdersAndAppointments"));
const TestOrdersDesign = lazy(() => import("@/pages/TestOrdersDesign/TestOrdersDesign"));
const ConfirmationRequests = lazy(() => import("@/pages/ConfirmationRequests/ConfirmationRequests"));
const ReadyTests = lazy(() => import("@/pages/ReadyTests/ReadyTests"));
const OpenedDNAOrder = lazy(() => import("@/pages/MyOrders/Nested/OpenedDNAOrder/OpenedDNAOrder"));
const EditDNAOrder = lazy(() => import("@/pages/MyOrders/Nested/EditDNAOrder/EditDNAOrder"));

const DNAOrderLabQuestions = lazy(() => import("@/pages/MyOrders/Nested/DNAOrderLabQuestions/DNAOrderLabQuestions"));

const urlsConfig = new UrlsConfig();

export function ordersRoutes() {
    return (
      <>
          <Route path={urlsConfig.ordersAndAppointments.to} element={<OrdersAndAppointments/>}/>
          <Route path={urlsConfig.testOrdersDesign.to} element={<TestOrdersDesign/>}/>
          <Route path={urlsConfig.confirmationRequests.to} element={<ConfirmationRequests/>}/>
          <Route path={urlsConfig.readyTests.to} element={<ReadyTests/>}/>
          <Route path={`${urlsConfig.openedOrder.to}/:orderNum`} element={<OpenedDNAOrder/>}/>
          <Route path={urlsConfig.editOrder({orderId: ":orderId"}).to} element={<EditDNAOrder/>}/>
          <Route
            path={urlsConfig.orderLabQuestions({orderId: ":orderId", questionId: ":questionId"}).to}
            element={<DNAOrderLabQuestions/>}
          />
      </>
    );
}
